import { NavLink } from 'react-router-dom';
import { fontStyles } from 'styles/theme';
import styled from '@emotion/styled';

export const BrandingTextContainer = styled(NavLink)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'flex-start',
  fontSize: 15,
  color: fontStyles.colors.primary,
});

export const BrandLogoContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: 16,
});
